
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DELETE_LETTER_TEMPLATE } from '../store';
import { LetterTemplate, WriteLetterTemplate } from '../types';
import { ApiResponse } from '@/components/types';
import { MapStateLetterTemplateToWriteLetterTemplate } from '../model';
import ErrorAlert from '@/components/ErrorAlert.vue';

const Correspondence = namespace('correspondence');

@Component({
  components: { ErrorAlert }
})
export default class DeleteLetterTemplateDialog extends Vue {
  @Prop({ type: [Object, Boolean] }) letterTemplate?: LetterTemplate;

  @Correspondence.Action(DELETE_LETTER_TEMPLATE) deleteTemplate!: (letterTemplate: WriteLetterTemplate) => Promise<ApiResponse>;

  error: any = null;
  loading: boolean = false;
  dialog: boolean = false;
  value: WriteLetterTemplate | null = null;

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (value !== false) return;

    setTimeout(() => {
      this.error = null;
      this.dialog = false;
      this.value = null;
      this.$emit('update:letterTemplate', null);
    }, 200);
  }

  @Watch('letterTemplate')
  watchOutbox(letterTemplate: LetterTemplate) {
    if (!letterTemplate) return;

    this.value = MapStateLetterTemplateToWriteLetterTemplate(letterTemplate);

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  async save() {
    if (!this.value) return;

    this.error = null;
    this.loading = true;

    const { error } = await this.deleteTemplate(this.value);

    this.loading = false;

    if (error) {
      this.error = error;
      return;
    }

    this.dialog = false;
  }
}
